import { render, staticRenderFns } from "./select-promotion-type.vue?vue&type=template&id=5b35da53"
import script from "./select-promotion-type.vue?vue&type=script&lang=js"
export * from "./select-promotion-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports